import { useMemo } from 'react';

import type { Locale } from '@change-corgi/config/locales';
import type { TrackingFn } from '@change-corgi/core/react/tracking';
import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

export type ShareActionContext = {
	countryCode: string;
	locale: Locale;
	utilityContext: UtilityContext;
	track: TrackingFn;
};

export function useActionContext(): ShareActionContext {
	const utilityContext = useUtilityContext();
	const track = useTracking();
	const countryCode = useCountryCode();
	const locale = useLocale();

	return useMemo(() => {
		return {
			utilityContext,
			track,
			countryCode,
			locale,
		};
	}, [utilityContext, track, countryCode, locale]);
}
